import React from 'react';
import { FormattedMessage } from 'react-intl';

const MorePopoverStrings = {
  disconnectButton: <FormattedMessage id="calendar.connect_cta.button_disconnect" defaultMessage="Disconnect"/>
};

export default MorePopoverStrings;
